// Ensure all cases of a switch statement have been exhausted.
export function exhaustiveGuard(value: never, message?: string): never {
  throw new Error(
    `Reached forbidden guard function with unexpected value: ${JSON.stringify(
      value
    )}${message ? `: ${message}` : ""}`
  )
}
